/**
 * useAuth hook.
 *
 * Convenience reader for the auth slice. Use this instead of useAppSelector
 * for auth state - keeps the auth shape encapsulated.
 */
import { useAppSelector } from "@/app/store/hooks";

/** Hook: read the auth slice (tokens, tenant, user) through a stable surface. */
export function useAuth() {
  return useAppSelector((state) => state.auth);
}

/** Hook: true if the user currently has valid auth tokens. */
export function useIsAuthenticated(): boolean {
  return useAppSelector((state) => Boolean(state.auth.accessToken));
}

/** Hook: the currently authenticated user, or null. */
export function useCurrentUser() {
  return useAppSelector((state) => state.auth.user);
}
